module.exports = __webpack_public_path__ + "img/enchant_item.fecbbc61.gif";